import { BotBubble } from './BotBubble';
import { UserBubble } from './UserBubble';

interface QuestionTurnProps {
  question: string;
  answer: string;
  showTypingDots: boolean;
}

export function QuestionTurn({
  question,
  answer,
  showTypingDots,
}: QuestionTurnProps) {
  return (
    <>
      <BotBubble showTypingDots={showTypingDots}>{question}</BotBubble>
      {answer && <UserBubble>{answer}</UserBubble>}
    </>
  );
}
